import { Link } from "react-router";
import { Icon } from "./Icon";

/** The prototype's back link (`.ctx-back`): an arrow and the place it returns to. */
export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link className="ctx-back" to={to}>
      <Icon name="left" />
      <span className="bl">{label}</span>
    </Link>
  );
}
